<template>
  <div class="files-wrapper">
    <div class="files-container">
      <!-- <div class="text-container"> </div> -->
      <!-- <tr-ui-title
        v-for="(title, index) in [files.filesObj]"
        :key="files.id + '_' + index"
        class="free-position"
        :style="getCustomStyle(files.filesObj)"
        :title-text="titleTextChoose(files.tooltip, files.text)"
        :width="870"
        :height="145"
      ></tr-ui-title> -->
      <div class="title-text-2" v-html="'Pobierz pliki'"></div>
      <div class="title-text" v-html="titleTextChoose(files.tooltip, files.text)"></div>
      <div class="list-container">
        <div
          class="image-container"
          :style="{ 'margin-top': files.spacebetween }"
          v-for="item in files.items"
          :key="item.id"
          title="Aby rozpocząć, kliknij w przycisk."
          @click="filesLuncher(item.path)"
        >
          <div class="image-element" title="Aby rozpocząć, kliknij w przycisk." @click="filesLuncher(item.path)">
            <img draggable="false" :src="imagePath(item.path, item.icon)" class="icon-off" />
            <img draggable="false" :src="imagePath(item.path, item.icon, false)" class="icon-on" />
          </div>
          <div class="file-name" v-html="item.fileName"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
// import TrUiTitle from '__mainSrcDir/components/TrGame/v4/UI/TrUiTitle/TrUiTitle';
import { stat } from 'fs';
export default {
  name: 'ps-files',
  // components: {
  //   TrUiTitle,
  // },
  data() {
    return {
      canIClick: true,
    };
  },
  methods: {
    titleTextChoose(tooltip, text) {
      // if (tooltip) {
      //   return tooltip;
      // }
      if (text) {
        return text;
      }
      return 'Kliknij na wybrany plik, aby go pobrać.<br />W razie problemów zainstaluj program do obsługi plików PDF.';
      // <br /><a href="https://get2.adobe.com/reader/">https://get2.adobe.com/reader/</a>';
    },
    openFile(link) {
      if (this.canIClick) {
        this.canIClick = false;

        const path = require('path');
        let fullLink;
        let base;
        if (!this.$store.getters.isWeb) {
          if (require('os').platform() === 'win32') {
            console.log('WIN32');
            base = path.win32.resolve();
          } else {
            console.log('LINUX');
            base = path.posix.resolve();
          }
          // fullLink = path.join(base, '/static/' + link);
          fullLink = path.join(base, '/static/', this.$store.getters.multibookType, link);
          this.$electron.shell.openItem(fullLink);
        } else {
          console.log('THIS IS WEB');
          let tmplink = link;
          let url = document.createElement('a');
          url.href = '/static/' + this.$store.getters.multibookType + '/' + tmplink;
          url.download = tmplink.substr(tmplink.lastIndexOf('/') + 1);
          console.log(url);
          url.click();
        }
        setTimeout(() => {
          this.canIClick = true;
        }, 550);
      }
    },
    filesLuncher(link) {
      console.log('link', link);
      if (link) {
        this.openFile(link);
        return true;
      }
      return false;
    },
    imagePath(path, staticIcon, off = true) {
      let icon = path.slice(((path.lastIndexOf('.') - 1) >>> 0) + 2);
      let newIcon = '';
      console.log('icona', icon);
      switch (icon) {
        case 'doc':
          newIcon = 'ikonaWord';
          break;
        case 'docx':
          newIcon = 'ikonaWord';
          break;
        case 'pdf':
          newIcon = 'ikonaPdf';
          break;
      }
      //   fixme
      if (staticIcon) {
        newIcon = staticIcon;
      }
      let images = require.context('../../../assets/icons/book/filesIcons/', false, /\.png$/);
      return images('./' + newIcon + '.png');
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    files() {
      return this.$store.getters.filesData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>
<style lang="scss" scoped>
.files-container {
  width: 820px;

  z-index: 999;
  background-color: #fff;
  position: absolute;
  top: 250px;
  padding-bottom: 20px;
  left: 460px;
  .title-text {
    height: 10%;
    width: 100%;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 20px;
    display: 'flex';
    font-size: 24px;
    text-align: left;
    margin-left: 10px;
  }
  .title-text-2 {
    height: 10%;
    width: 100%;
    padding-left: 20px;
    padding-top: 30px;
    padding-bottom: 0px;
    display: 'flex';
    font-size: 24px;
    text-align: left;
    margin-left: 10px;
  }
  .list-container {
    justify-content: center;
    display: flex-start;
    // margin-top: 100px;
    // padding: 10px;
    height: 100%;
    width: 100%;
    align-items: flex-end;
  }
  .image-container {
    // position: relative;
    width: 90%;
    z-index: 1006;
    cursor: pointer;
    visibility: visible;
    transition: all 0.2s ease-in-out;
    background-size: contain;
    opacity: 1;
    display: flex;
    pointer-events: initial;
    // top: 195px;
    // left: 345px;
    align-items: center;
    // margin: 20px;
    // width: 83px;
    padding-left: 30px;
    height: 65px;

    .file-name {
      width: calc(100% - 50px);
      display: 'flex';
      text-align: left;
      // margin-top: auto;
      // margin-bottom: auto;
      align-items: center;
      // height: 100%;

      font-size: 18px;
      margin-left: 10px;
    }
    .image-element {
      width: 50px;
      height: 50px;
      z-index: 1005;

      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      visibility: visible;
      opacity: 1;
      cursor: pointer;
      // transition: visibility 0s, opacity 0.3s ease-in;
    }
    // .image-element:hover {
    //   transform: scale(1.3);
    //   transition: 0.4s;

    //   // transition: visibility 0s, opacity 0.3s ease-in;
    // }
    .image-element .icon-off {
      visibility: visible;
      opacity: 1;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1006;
      width: 100%;
      height: 100%;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      transition: visibility 0s, opacity 0.3s ease-out;
    }
    .image-element .icon-on {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1006;
      width: 100%;
      height: 100%;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      transition: visibility 0s, opacity 0.3s ease-out;
    }
    .image-element:hover .icon-on {
      visibility: visible;
      opacity: 1;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      // transition: visibility 0s, opacity 0.3s ease-in;
    }
    // }
  }
  .image-container:hover {
    transform: scale(1.03);
    transition: 0.4s;
  }

  .free-position {
    position: absolute;
    pointer-events: auto;
    z-index: 1006;
  }
}
</style>
